/**
 * 列表查询公共参数构造。
 * 对齐小程序请求体格式（见 miniProgram/pages/index/index.js 等页面）。
 */

export interface ListQueryOptions {
  /** 页码，默认 1 */
  pageIndex?: number;
  /** 每页条数，默认 10 */
  pageSize?: number;
  /** 状态 0-不限 1-启用 2-关闭（默认值由各接口调用方指定） */
  state?: number;
  /** 主键 id（列表查询一般为 0） */
  id?: number;
  /** 名称模糊查询 */
  name?: string;
  /** 接口特有字段 */
  extra?: Record<string, unknown>;
}

/** 构造后端 BasePageRequest 兼容的请求体 */
export function buildListParams(options: ListQueryOptions = {}): Record<string, unknown> {
  const { pageIndex = 1, pageSize = 10, state = 0, id = 0, name = '', extra = {} } = options;

  return {
    id,
    page: { pageIndex, pageSize },
    state,
    startTime: '',
    endTime: '',
    field: '',
    order: '',
    descStr: '',
    authPlatformType: 0,
    name,
    ...extra,
  };
}
